import React, { Suspense } from "react";
//import { Icon } from "@iconify/react/dist/iconify.js";
export function Loader(props) {
  var loadingMessage =
    props.loadingMessage !== undefined && props.loadingMessage !== ""
      ? props.loadingMessage
      : "Please wait...";
  return (
    <>
      <div className="page-loading text-center">
        <div className="content">
          {/* <img
            src="dist/img/logo-utwiz.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "} */}
          <img
            src="dist/img/logo-zenplus.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "}
          <h6 className="mb-0">{loadingMessage}</h6>
        </div>
      </div>
    </>
  );
}

export function LogoutLoader() {
  return (
    <>
      <div className="page-loading text-center">
        <div className="content">
          {/* <img
            src="dist/img/logo-utwiz.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "} */}
          <img
            src="dist/img/logo-zenplus.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "}
          <h6 className="mb-0">Logging out...</h6>
        </div>
      </div>
    </>
  );
}

export function ButtonLoader(props) {
  return (
    <img
      src="/dist/img/svg-spinners-3-dots-fade.svg"
      width={props?.width ?? 36}
    />
    // <Icon
    //   icon="svg-spinners:3-dots-fade"
    //   width="24"
    //   height="24"
    //   //style={{ color: "#f7f2f2ff" }}
    // />
  );
}
